import React from "react";
import Appbar from "components/Appbar";
import Breadcrumbs from "components/Breadcrumbs";
import Footer from "components/Footer";
import background from "assets/image/background_V2_re.png";
import { Box, Grid } from "@mui/material";
import { isAuth as isAuthen } from "../../apollo/cache";
import MaintenanceNotic from "./components/MaintenanceNotic";
import { useReactiveVar } from "@apollo/client";
import { maintenanceDetail, isMaintenance as isMaintenanceVar } from "../../apollo/cache";
import { styled } from "@mui/material";

const Background = styled(Box)`
  background: #fafafa;
  position: relative;
  height: 100%;
  ${({ isbackground }) => {
    if (isbackground) {
      return `background: linear-gradient(250.8deg, rgb(254 255 255 / 80%), rgb(254 255 255 / 80%) 100%), url(${background}), no-repeat; 
      background-blend-mode: luminosity;`;
    }
  }};
  min-height: 100vh;
`;
const Layout = styled(`div`)`
  min-height: 100vh;
  margin: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  /* display: grid;
  grid-template-rows: auto 1fr auto; */
`;
const Content = styled(`div`)`
  /* margin-bottom: 60px; */
  ${(props) => props.theme.breakpoints.down("sm")} {
    padding: 10px 20px 70px 20px;
  }
  padding: 20px 40px 70px 40px;
`;
const FooterDiv = styled(Grid)`
  margin-top: 64px;
  background-color: #ffffff;
`;

const Main = styled(Grid)`
  -webkit-box-flex: 1;
  -ms-flex: 1;
  flex: 1;
`;

const index = ({ children, BreadcrumbsItems, isBackground=false, styleBackground = {}, components={} }) => {
  const isAuth = isAuthen();
  const notiDetail = useReactiveVar(maintenanceDetail);
  const isMaintenance = useReactiveVar(isMaintenanceVar);
  const closeNoti = () => {
    isMaintenanceVar(false);
  };

  return (
    <Background isbackground={isBackground ? 1 : 0} sx={styleBackground}>
      <Layout>
        <Box>
          <Appbar isAuth={isAuth} />
        </Box>
        <Main>
          <Box>
            <MaintenanceNotic
              details={notiDetail?.details}
              formDate={notiDetail?.fromDate}
              toDate={notiDetail?.toDate}
              state={isMaintenance}
              handleCloseNoti={closeNoti}
            />
            {components?.bottomAppbar}
          </Box>
          {BreadcrumbsItems && (
            <div style={{ margin: "15px 40px 15px" }}>
              <Breadcrumbs items={BreadcrumbsItems} />
            </div>
          )}
          <Content>{children}</Content>
        </Main>
        <FooterDiv>
          <Footer />
        </FooterDiv>
      </Layout>
    </Background>
  );
};

export default index;
